import React from 'react'
import ContactForm from './contactForm/contactForm'
import GoogleMap from './googleMap/googleMap'

function Contacts() {
    return (
        <>
            <ContactForm />

            <GoogleMap />
        </>
    )
}

export default Contacts